import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from '@/theme/theme';
import { installGlobalErrorHandlers } from '@/services/errorHandler/globalErrorHandler';
import { logger } from '@/services/logger';
import { App } from './App';
import './styles/global.css';

installGlobalErrorHandlers();

function onPageHide(): void {
  logger.flush();
}
window.addEventListener('pagehide', onPageHide);

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StrictMode>
);
